/**
 * 任意の文字列を「安全な内部パス」に正規化する。Open Redirect 防御。
 *
 * `redirect` クエリパラメータや sessionStorage に積まれた戻り先 URL など、
 * 外部由来の文字列をルーター遷移に渡す前に必ず通す。許可するのは現在の origin 配下の
 * 相対パスのみで、絶対 URL / protocol-relative (`//`) / backslash / URL エンコード
 * 経由のトラバーサル / 制御文字 / 先頭空白は全て拒否する。
 *
 * @returns 正規化済みの `pathname + search + hash`。安全でなければ `null`。
 */
export function toSafeInternalPath(
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  if (!value.startsWith('/')) return null;
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  if (/[\\\r\n\t]/.test(value)) return null;
  if (/^\/%(2f|5c)/i.test(value)) return null;

  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}
